module.exports = __webpack_public_path__ + "static/media/NotoSans-SemiBoldItalic.5894b4af.woff";